import { computed } from 'mobx';
import Store from './Store';
import StoresCollection from './StoresCollection';

class BopisStoresCollection extends StoresCollection {
  @computed
  get storesSortedByDistance(): Store[] {
    return this.stores?.sort((a, b) => a.distance - b.distance);
  }
}

export default BopisStoresCollection;
